export default __webpack_public_path__ + "img/delete.34c00c44.svg";